import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { Card } from '../common/Card';
import { mockSongs } from '../../data/mockData';

interface TopSongsChartProps {
  limit?: number;
}

export const TopSongsChart: React.FC<TopSongsChartProps> = ({ limit = 10 }) => {
  const topSongs = mockSongs
    .sort((a, b) => b.streams - a.streams)
    .slice(0, limit)
    .map(song => ({
      title: song.title.length > 20 ? song.title.substring(0, 17) + '...' : song.title,
      streams: Math.floor(song.streams / 1000), // Convert to thousands for better display
      revenue: song.revenue,
      artist: song.artist
    }));

  const formatTooltipValue = (value: number, name: string) => {
    if (name === 'streams') {
      return [`${(value * 1000).toLocaleString()}`, 'Streams'];
    }
    return [`$${value.toLocaleString()}`, 'Revenue'];
  };

  return (
    <Card>
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-lg font-semibold text-white font-display">
          Top Performing Songs
        </h3>
        <div className="text-sm text-gray-400">
          By streams (last 30 days)
        </div>
      </div>
      
      <div className="h-80">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart
            data={topSongs}
            margin={{ top: 20, right: 30, left: 20, bottom: 60 }}
          >
            <CartesianGrid strokeDasharray="3 3" stroke="#374151" />
            <XAxis 
              dataKey="title"
              stroke="#9CA3AF"
              fontSize={12}
              angle={-45}
              textAnchor="end"
              height={80}
            />
            <YAxis 
              stroke="#9CA3AF"
              fontSize={12}
              tickFormatter={(value) => `${value}K`}
            />
            <Tooltip
              formatter={formatTooltipValue}
              labelFormatter={(label) => `Song: ${label}`}
              contentStyle={{
                backgroundColor: '#1F2937',
                border: '1px solid #374151',
                borderRadius: '8px',
                color: '#FFFFFF'
              }}
            />
            <Bar 
              dataKey="streams" 
              fill="#FFD700"
              radius={[4, 4, 0, 0]}
            />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </Card>
  );
};